import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { FicScreenRef } from './fic-screen-injecotors';
import { FicScreenRefModel } from './fic-screen-ref';

@Component({
    selector: 'fic-screen',
    template: `<ng-content></ng-content>`,
    encapsulation: ViewEncapsulation.None,
    styleUrls: ['./fic-screen.component.scss'],
    host: { class: 'fic-screen' },
    standalone: false,
})
export class FicScreenComponent {
    constructor(@Inject(FicScreenRef) public screenRef: FicScreenRefModel<any, any>) {}
}
